module.exports = __webpack_public_path__ + "assets/img/img-tutorial00.d26a91ad.png";